import React from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

import logoJanisBlack from './logo-janis-black.svg';
import UserChip from './UserChip';

const Header = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 10;
	width: 100%;
	padding: 10px 5%;
	background-color: #FFF;
	height: 70px;
	line-height: 50px;
	display: flex;
	justify-content: space-between;
	box-sizing: border-box;
`;

const LogoWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-self: center;
`;

const StyledLink = styled(Link)`
	line-height: 28px;
	color: #FFF;
	text-decoration: none;
`;

const Logo = styled.img`
	height: 28px;
	padding: 0;
	vertical-align: middle;
`;

const ServicesLink = styled(Link)`
	color: #2979FF;
	font-size: 10px;
	font-weight: 500;
	line-height: 11px;
	text-decoration: none;
	letter-spacing: 0.77px;
	text-transform: uppercase;
	margin-bottom: 2px;
`

export default ({
	servicesLinkTarget
}) => {

	return (
		<Header>
			<LogoWrapper>
				{servicesLinkTarget && <ServicesLink to={servicesLinkTarget} title="Services" >Services</ServicesLink>}
				<StyledLink to="/" title="Go to home">
					<Logo src={logoJanisBlack} alt="Janis Logo" />
				</StyledLink>
			</LogoWrapper>
			<UserChip />
		</Header>
	);
};
